import React, { useState } from "react";
import ClipLoader from 'react-spinners/ClipLoader';
import { addDoc, collection, db } from "../../firebase"; // Ajusta la ruta si es necesario

import { toast } from "react-toastify";

const InfoSection = (props) => {

  const [isLoading, setIsLoading] = useState(false);  // Estado para el loader

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    seats: 1,
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setIsLoading(true);
      // Guardar los datos en Firebase Firestore
      await addDoc(collection(db, "HAIR"), {
        name: formData.name || "",
        phone: formData.phone || "",
        seats: formData.seats || null,
        timestamp: new Date(), // Fecha de envío
      });

      // Desplazarse al elemento con id "campo-nombre"
      const elemento = document.getElementById("hair");
      if (elemento) {
        const posicion = elemento.getBoundingClientRect().top + window.scrollY; // Calcula la posición en la página
        window.scrollTo({
          top: posicion - "0", // Aplica el offset restándolo
          behavior: "smooth", // Desplazamiento suave
        });
      }
      setFormSubmitted(true);
    } catch (error) {
      toast.error('Ha habido un error en el envío', {
        position: "top-center", // Posición central superior
        autoClose: 3000, // Tiempo de duración (en milisegundos)
        hideProgressBar: true, // Mostrar barra de progreso
        closeOnClick: true, // Cierre al hacer clic
        pauseOnHover: true, // Pausa al pasar el cursor
        draggable: true, // Permitir arrastrar el toast
        progress: undefined, // Barra de progreso predeterminada
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className={`section-padding`} id="info">
      {/* Mostrar el loader mientras isLoading sea verdadero */}
      {isLoading && (
        <div className="loader-overlay">
          <ClipLoader color="#fff" loading={isLoading} size={50} />
        </div>
      )}
      <div class="wpo-cta-section wpo-info-section">
        <div class="conatiner-fluid">
          <div class="wpo-cta-item">
            <h2>Información interesante</h2>
            {/* <p class="p-0 m-0" style={{color: 'white'}}>(Te damos todas las opciones para que elijas la que más te convenga 😉)</p> */}
          </div>
        </div>
      </div>
      <div class="container">
        <div class="flex mt-5 px-4">
          <div class="col-12 col-lg-6 mx-auto mb-5">
            <h1>🚗🚆✈️ Opciones para llegar a Jaén</h1>
            <p>Jaén está perfectamente conectada, así que llegar hasta aquí es más fácil de lo que piensas. Aquí tienes las mejores opciones:</p>

            <h2 class="mt-4">1. En coche 🚗</h2>
            <p>Si prefieres la libertad de conducir, Jaén está bien comunicada por carretera:</p>
            <p>
              <ul>
                <li><strong>Desde Madrid:</strong> Aproximadamente 3 horas y media por la A-4.</li>
                <li><strong>Desde Sevilla:</strong> Unas 2 horas y media por la A-92 y A-316.</li>
                <li><strong>Desde Granada:</strong> Menos de 1 hora por la A-44.</li>
                <li><strong>Desde Tarragona:</strong> Aproximadamente 6 horas y media por la AP-7 y la A-4.</li>
              </ul>
            </p>
            <p>El hotel cuenta con parking, así que no tendrás que preocuparte por dejar tu coche.</p>

            <h2 class="mt-4">2. En tren 🚆</h2>
            <p>La estación de tren de Jaén está a solo <strong>10 minutos en coche</strong> del hotel:</p>
            <p>
              <ul>
                <li>Trenes directos desde <strong>Madrid</strong> (unas 4 horas) y <strong>Córdoba</strong> (1 hora y media).</li>
                <li>Desde otras ciudades como Sevilla o Málaga, es posible que necesites hacer un trasbordo en Córdoba.</li>
                <li>Desde Tarragona, el trayecto en tren dura entre 7 y 8 horas, generalmente con transbordo en Madrid o Córdoba.</li>
              </ul>
            </p>

            <h2 class="mt-4">3. En avión ✈️</h2>
            <p>Los aeropuertos más cercanos son:</p>
            <p>
              <ul>
                <li><strong>Aeropuerto de Granada-Jaén (GRX):</strong> A 1 hora en coche. Conectado con vuelos nacionales e internacionales.</li>
                <li><strong>Aeropuerto de Málaga-Costa del Sol (AGP):</strong> A 2 horas en coche. Ofrece más opciones de vuelos internacionales.</li>
              </ul>
            </p>
            <p>Desde ambos aeropuertos puedes alquilar un coche o tomar un traslado privado hasta Jaén.</p>

            <h2 class="mt-4">4. En autobús 🚌</h2>
            <p>La estación de autobuses de Jaén está a solo <strong>15 minutos en coche</strong> del hotel:</p>
            <p>
              <ul>
                <li>Hay conexiones directas desde ciudades como <strong>Madrid</strong>, <strong>Sevilla</strong>, <strong>Granada</strong> y <strong>Córdoba</strong>.</li>
              </ul>
            </p>

            <p className="mt-5" >Si necesitas más información sobre cómo llegar, no dudes en contactarnos. ¡Estaremos encantados de ayudarte! 😊</p>
          </div>
        </div>
      </div>

      <div class="wpo-cta-section wpo-jaen-section">
        <div class="conatiner-fluid">
          <div class="wpo-cta-item">
            <h2>Qué hacer en Jaén
            </h2>
            {/* <p class="p-0 m-0" style={{color: 'white'}}>(Te damos todas las opciones para que elijas la que más te convenga 😉)</p> */}
          </div>
        </div>
      </div>
      <div class="container">
        <div class="flex mt-5 px-4">
          <div class="col-12 col-lg-6 mx-auto">
            <p> Si tenéis tiempo libre por Jaén y no sabéis qué hacer, aquí os dejamos algunas recomendaciones y curiosidades de esta ciudad tan poco conocida: </p>

            <h2 class="mt-4">Descubre el centro de Jaén 🏰🌳</h2>
            <p>Una vez que llegues al <strong>Hotel HO Ciudad de Jaén</strong>, te encontrarás a tan solo 10 minutos del corazón de la ciudad, cerca de algunos de los lugares más emblemáticos.</p>
            <p>
              <ul>
                <li className="mt-3"><strong>Catedral de Jaén 🕍:</strong> Una joya del Renacimiento español. No te pierdas su fachada y las vistas desde su torre. Se dice que esta catedral inspiró el diseño de la Catedral de la Habana en Cuba.</li>
                <li className="mt-3"><strong>Castillo de Santa Catalina 🏰:</strong> Ofrece vistas espectaculares de la ciudad. Construido por los musulmanes en el siglo IX, fue reformado por Fernando III tras la reconquista cristiana en el siglo XIII.</li>
                <li className="mt-3 top-recommendation">
                  <strong>Zona de las Tascas 🍷:</strong> El corazón gastronómico de Jaén, donde podrás disfrutar de auténticas tapas y platos tradicionales acompañados de los mejores vinos y aceites de oliva. ¡Obligatorio si podéis, venir por aquí!
                  <span className="top-badge">TOP</span>
                </li>
                <li className="mt-3"><strong>Parque del Bulevar 🌳:</strong> Un espacio verde perfecto para relajarse, pasear o disfrutar de un momento tranquilo. Con sus fuentes, zonas de descanso y ambiente familiar, es ideal para desconectar en pleno centro de Jaén.</li>
                <li className="mt-3"><strong>Baños Árabes 🧖‍♂️:</strong> Situados en el Palacio de Villardompardo, son uno de los mejor conservados de España. Fueron construidos en el siglo XI durante la dominación musulmana y muestran la gran influencia árabe en la región.</li>
                {/* <li className="mt-3"><strong>Paseo de la Estación 🌳:</strong> Ideal para pasear y probar el famoso aceite de oliva de Jaén. Esta avenida ha sido testigo de la evolución de la ciudad desde finales del siglo XIX.</li> */}
                <li className="mt-3"><strong>Museo de Jaén 🖼️:</strong> Perfecto para los amantes del arte y la historia. Cuenta con una de las mejores colecciones de esculturas íberas de España, destacando los restos de la antigua ciudad íbero-romana de Cástulo.</li>
              </ul>
            </p>

            <h2 class="mt-4">🌄 Pueblos con encanto cerca de Jaén</h2>
            <p>Si tienes tiempo y ganas de explorar, aquí os dejamos una selección de pueblos que a nosotros nos encanta visitar:</p>
            <p>
              <ul>
                <li className="mt-3">
                  <strong>Úbeda 🏛️:</strong> Declarada Patrimonio de la Humanidad, Úbeda es un museo al aire libre de arquitectura renacentista. No te pierdas su Plaza Vázquez de Molina, una de las más bonitas de España.
                </li>
                <li className="mt-3">
                  <strong>Baeza 🕍:</strong> Junto a Úbeda, Baeza es otra joya renacentista y Patrimonio de la Humanidad. Sus calles empedradas y su impresionante catedral te transportarán a otra época.
                </li>
                <li className="mt-3">
                  <strong>Cazorla 🌿:</strong> La puerta de entrada al Parque Natural de las Sierras de Cazorla, Segura y Las Villas. Ideal para los amantes de la naturaleza y los paisajes de montaña.
                </li>
                <li className="mt-3">
                  <strong>Alcalá la Real 🏰:</strong> Con su imponente Fortaleza de la Mota, este pueblo ofrece unas vistas espectaculares y una rica historia ligada a la frontera entre cristianos y musulmanes.
                </li>
              </ul>
            </p>
            <p>Cada uno de estos pueblos tiene algo único que ofrecer, ya sea historia, naturaleza o gastronomía. ¡Son el complemento perfecto para tu visita a Jaén! 😊</p>

            <h2 class="mt-4">Curiosidades</h2>
            <p>
              <ul>
                <li className="mt-3"><strong>🌳 El mar de olivos:</strong> Jaén es la capital mundial del aceite de oliva. Con más de <strong>66 millones de olivos</strong>, es la provincia con mayor producción de aceite de oliva del mundo. ¡Imagina un mar infinito de árboles que parece no tener fin!</li>
                <li className="mt-3"><strong>🏰 Tierra de castillos:</strong> Jaén es conocida como la <strong>"Tierra de Castillos y Batallas"</strong>. Con más de <strong>237 castillos y fortalezas</strong>, es la provincia con mayor concentración de estas construcciones en toda Europa. ¡Una auténtica ruta medieval te espera!</li>
                <li className="mt-3"><strong>🏞️ Naturaleza desbordante:</strong> Con <strong>4 parques naturales</strong> (incluyendo las impresionantes Sierras de Cazorla, Segura y Las Villas, el mayor espacio protegido de España), Jaén es un paraíso para los amantes de la naturaleza.</li>
                <li className="mt-3"><strong>📜 Historia milenaria:</strong> Jaén ha sido testigo del paso de civilizaciones como los íberos, romanos, musulmanes y cristianos.</li>
              </ul>
            </p>
            <p>Si necesitas más información sobre qué visitar, no dudes en contactarnos. ¡Estaremos encantados de ayudarte! 😊</p>
          </div>
        </div>
      </div>
    </section>

  );
};

export default InfoSection;
